var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dora_indicators"},[_vm._l((_vm.Wanpai),function(tile,i){return [(_vm.show_only)?[(tile == -1)?_c('TileImage',{key:i,attrs:{"tile":tile}}):_c('TileImage',{key:i,attrs:{"tile":tile}})]:[(tile == -1)?_c('TileImage',{key:i,attrs:{"tile":tile}}):_c('TileButton',{key:i,attrs:{"tile":tile},on:{"click-tile":_vm.removeDora}})]]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }